import { render, staticRenderFns } from "./RightArrow.vue?vue&type=template&id=5e5b602b&scoped=true&"
import script from "./RightArrow.vue?vue&type=script&lang=js&"
export * from "./RightArrow.vue?vue&type=script&lang=js&"
import style0 from "./RightArrow.vue?vue&type=style&index=0&id=5e5b602b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5b602b",
  null
  
)

export default component.exports